/** Barrett M82, as a thing you can carry. The gun itself is `sim/weapons/guns/m82.ts`. */

import { NO_ARMOR } from '@/sim/combat/armorMitigation';
import type { WeaponItem } from '@/sim/items/itemContract';

export const M82_ITEM = {
  id: 'm82',
  kind: 'weapon',
  label: 'Barrett M82',
  description:
    'Fourteen kilos of .50 calibre. What it is aimed at stops being a problem. So does the wall.',
  rarity: 'exotic',
  weightKg: 14.0,
  stackLimit: 1,
  equip: {
    slots: ['primaryWeapon'],
    statDeltas: {},
    armor: NO_ARMOR,
    damageModifiers: [],
  },
  weaponId: 'm82',
} as const satisfies WeaponItem;
